<script>
import { QTabPanels } from 'quasar'
// import { mergeData } from 'vue-functional-data-merge'

export default {
  functional: true,
  props: {
    animated: {
      type: Boolean,
      default: true
    }
  },
  render (createElement, { props, data, children }) {
    return createElement(QTabPanels, data, children)
  }
}
</script>
